import Axios from 'axios';
import { ChatRequest, ChatResponse } from '../models/chatbot';

const chatbotAxios = Axios.create({
  baseURL: process.env.REACT_APP_CHATBOT_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-Purchase-Key': process.env.REACT_APP_CHATBOT_API_KEY ?? '',
  },
});

export const sendChatMessage = async (request: ChatRequest): Promise<ChatResponse> => {
  const response = await chatbotAxios.post<ChatResponse>('/purchase/chat', request);
  return response.data;
};
